/* angular:styles/component:css;58216c2eb04ac05a73a136c3c2d1c2a582555de38417255abec3865ef3fac42b;C:\Users\kevinm\source\repos\efaactcentral\efaact.central\efaact.central.web\src\app\login\login.component.ts */
.overlay {
  position: absolute;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  background-color: #333;
  background-color: rgba(0, 0, 0, 0.5);
}
/*# sourceMappingURL=login.component.css.map */
